import { render, staticRenderFns } from "./StringComponent.vue?vue&type=template&id=27648b7d&"
import script from "./StringComponent.vue?vue&type=script&lang=ts&"
export * from "./StringComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports